/** Снимок текущего выделения в документе (для восстановления после copy/focus). */
export function captureDocumentSelection(): Range[] {
  if (typeof window === 'undefined') return [];
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return [];
  const ranges: Range[] = [];
  for (let i = 0; i < sel.rangeCount; i++) {
    ranges.push(sel.getRangeAt(i).cloneRange());
  }
  return ranges;
}

export function restoreDocumentSelection(ranges: Range[]): void {
  if (!ranges.length || typeof window === 'undefined') return;
  const sel = window.getSelection();
  if (!sel) return;
  sel.removeAllRanges();
  for (const range of ranges) {
    try {
      sel.addRange(range);
    } catch {
      /* узлы могли размонтироваться */
    }
  }
}

/** Восстановить выделение после закрытия меню / смены focus (следующий кадр). */
export function scheduleRestoreDocumentSelection(ranges: Range[]): void {
  if (!ranges.length) return;
  const run = () => restoreDocumentSelection(ranges);
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => requestAnimationFrame(run));
  } else {
    setTimeout(run, 0);
  }
}
